export const TYPES = [
  { label: "short text", value: "SHORT_TEXT" },
  { label: "long text", value: "LONG_TEXT" },
  { label: "checkbox", value: "CHECKBOX" },
  { label: "radio", value: "RADIO" },
  { label: "dropdown", value: "DROPDOWN" },
];
